import { atom } from 'jotai'

export const walletConnectionStatusAtom = atom<
  'disconnected' | 'connected' | 'reconnecting' | 'connecting'
>('disconnected')
export const userAddressAtom = atom<string>('')
